import React from "react";

/**
 * Unified premium atmosphere for the public marketing pages.
 *
 * Four stacked layers, all pointer-events:none and fixed to the viewport:
 *   1. Three slowly-drifting radial gradient blobs (emerald, purple, sky)
 *   2. Faint 1px radial-dot grid with a radial fade toward center
 *   3. SVG-turbulence grain overlay with mix-blend-mode: overlay
 *
 * Mount as the first child of a page root that is `relative isolate` so
 * the backdrop's negative z-index is captured inside the page's stacking
 * context (won't bleed under modals or the global ChatWidget).
 */
const MarketingBackdrop = () => (
  <div
    aria-hidden
    className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
  >
    {/* Drifting blobs */}
    <div className="absolute inset-0 hidden dark:block">
      <div
        className="absolute -top-40 -left-40 w-[640px] h-[640px] rounded-full blur-3xl opacity-[0.22]"
        style={{
          background: "radial-gradient(circle, #10b981, transparent 60%)",
          animation: "drift-a 48s ease-in-out infinite",
        }}
      />
      <div
        className="absolute -top-32 right-[-8rem] w-[720px] h-[720px] rounded-full blur-3xl opacity-[0.22]"
        style={{
          background: "radial-gradient(circle, #a855f7, transparent 60%)",
          animation: "drift-b 56s ease-in-out infinite",
        }}
      />
      <div
        className="absolute bottom-[-20%] left-1/2 -translate-x-1/2 w-[1000px] h-[520px] rounded-full blur-3xl opacity-[0.18]"
        style={{
          background: "radial-gradient(circle, #3b82f6, transparent 60%)",
          animation: "drift-c 64s ease-in-out infinite",
        }}
      />
    </div>

    {/* Light-theme blobs — much softer */}
    <div className="absolute inset-0 dark:hidden">
      <div
        className="absolute -top-40 -left-40 w-[560px] h-[560px] rounded-full blur-3xl opacity-25"
        style={{
          background: "radial-gradient(circle, #10b981, transparent 60%)",
        }}
      />
      <div
        className="absolute -top-20 right-0 w-[640px] h-[640px] rounded-full blur-3xl opacity-25"
        style={{
          background: "radial-gradient(circle, #a855f7, transparent 60%)",
        }}
      />
    </div>

    {/* Dot grid — dark mode only; light mode keeps it clean */}
    <div className="absolute inset-0 hidden dark:block bg-grid-dot" />

    {/* Film grain — last layer, blends over everything */}
    <div className="absolute inset-0 hidden dark:block bg-grain opacity-[0.06] mix-blend-overlay" />
  </div>
);

export default MarketingBackdrop;
